import { Component, Vue, Prop } from 'vue-property-decorator';
import { cliente } from '@/common/mock/clientes';

@Component({})
export class ListItems extends Vue {

    @Prop({})
    public slug?: string;
    public mock = cliente[(this.slug as string)];

}